import Storage from '../services/storage';
const storage = new Storage();
export default function (status) {
  storage.saveAndDelete('isCorporate', status);
}